import { render, staticRenderFns } from "./EmissionDualAxisChart.vue?vue&type=template&id=60523fe2&scoped=true"
import script from "./EmissionDualAxisChart.vue?vue&type=script&lang=js"
export * from "./EmissionDualAxisChart.vue?vue&type=script&lang=js"
import style0 from "./EmissionDualAxisChart.vue?vue&type=style&index=0&id=60523fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60523fe2",
  null
  
)

export default component.exports